import { render, staticRenderFns } from "./SubjectSelect.vue?vue&type=template&id=1115a7e3&"
import script from "./SubjectSelect.vue?vue&type=script&lang=js&"
export * from "./SubjectSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports